var React = require('react');

function BtnInstagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM24 16C24 11.5824 20.4176 8 16 8C11.5824 8 8 11.5824 8 16C8 20.4176 11.5824 24 16 24C20.4176 24 24 20.4176 24 16ZM11.2002 16C11.2002 13.3488 13.349 11.2 16.0002 11.2C18.6514 11.2 20.8002 13.3488 20.8002 16C20.8002 18.6511 18.6514 20.7999 16.0002 20.7999C13.349 20.7999 11.2002 18.6511 11.2002 16ZM26.489 7.80741C26.489 7.03052 25.8585 6.4 25.0816 6.4C24.3047 6.4 23.6742 7.03052 23.6742 7.80741C23.6742 8.5843 24.3047 9.21482 25.0816 9.21482C25.8585 9.21482 26.489 8.5843 26.489 7.80741Z","fill":"#AAAAAA"}));
}

BtnInstagram.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = BtnInstagram;

BtnInstagram.default = BtnInstagram;
